import React from 'react';
import { DashboardComponent } from '../Components/Dashboard';
export const Dashboard = (props) => {
  return <DashboardComponent {...props} />;
};
